import {
  ThemeOptions, createTheme,
} from '@mui/material';
import SatoshiBlack from './fonts/Satoshi-Black.woff2';
import SatoshiBold from './fonts/Satoshi-Bold.woff2';
import SatoshiReqular from './fonts/Satoshi-Regular.woff2';
import SatoshiMedium from './fonts/Satoshi-Medium.woff2';
import SatoshiLight from './fonts/Satoshi-Light.woff2';

export const themeOptions: ThemeOptions = {
  palette: {
    dividerLight: '#D9D9D9',
    grey: {
      500: '#868B8C',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Satoshi';
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          src: local('Satoshi'), local('Satoshi-Regular'), url(${SatoshiReqular}) format('woff2');
        }

        @font-face {
          font-family: 'Satoshi';
          font-style: normal;
          font-display: swap;
          font-weight: 500;
          src: local('Satoshi'), local('Satoshi-Medium'), url(${SatoshiMedium}) format('woff2');
        }

        @font-face {
          font-family: 'Satoshi';
          font-style: normal;
          font-display: swap;
          font-weight: 100;
          src: local('Satoshi'), local('Satoshi-Light'), url(${SatoshiLight}) format('woff2');
        }

        @font-face {
          font-family: 'Satoshi';
          font-style: normal;
          font-display: swap;
          font-weight: 700;
          src: local('Satoshi'), local('Satoshi-Bold'), url(${SatoshiBold}) format('woff2');
        }

        @font-face {
          font-family: 'Satoshi';
          font-style: normal;
          font-display: swap;
          font-weight: 900;
          src: local('Satoshi'), local('Satoshi-Black'), url(${SatoshiBlack}) format('woff2');
        }
        `,
    },
    MuiListItemAvatar: {
      styleOverrides: {
        root: {
          minWidth: 'auto',
          marginRight: '16px',
        },
      },
    },
  },

};
declare module '@mui/material/styles' {
  interface Palette {
    dividerLight: string;
  }
  interface PaletteOptions {
    dividerLight?: string;
  }
}

const theme = createTheme(themeOptions);

export default theme;
